<template>
  <div class="learning-setting-component">
    <div class="setting-item">
      <span class="item-title">专注模式</span>
      <el-switch
        class="live-room-switch"
        v-model="focusModeValue"
        :active-value="1"
        :inactive-value="2"
        active-color="#165DFF"
        inactive-color="#3F3F46"
        @change="handleFocusModeChange"
      ></el-switch>
    </div>
    <div class="tips">开启后，学员仅看到讲师和学员自己的头像</div>
    <div class="setting-item">
      <div class="item-title">
        锁屏模式

        <el-tooltip
          width="200"
          class="item"
          effect="dark"
          placement="top-start"
        >
          <img src="@saas/pages/assets/images/live/live-set/tips.png" alt="" />
          <div slot="content" class="tips-content">
            开启后，学生使用电脑进入课堂时，课堂窗口会保持最大化和置顶状态；<br />学生使用移动端进入学堂时，当切换其它软件，将自动退出课堂
          </div>
        </el-tooltip>
      </div>
      <el-switch
        class="live-room-switch"
        v-model="lockScreenModeValue"
        :active-value="1"
        :inactive-value="2"
        active-color="#165DFF"
        inactive-color="#3F3F46"
        @change="handleLockScreenModeChange"
      ></el-switch>
    </div>
    <common-dialog
      v-model="lockScreenModeDialogVisible"
      @confirm="handleLockScreenModeConfirm"
    >
      <template #content>
        <div class="tips-content-lock-screen">
          {{ lockScreenModeDialogContent }}
        </div>
      </template>
    </common-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { updateRoomStatus } from "@saas/server-api/src/live-sdk";
import CommonDialog from "../../../dialog/CommonDialog.vue";
export default {
  components: {
    CommonDialog,
  },
  data() {
    return {
      focusModeValue: 2,
      lockScreenModeValue: 2,
      lockScreenModeDialogVisible: false,
      lockScreenModeDialogContent: "！锁屏模式对网页端无效",
    };
  },
  mounted() {},
  computed: {
    ...mapState("live", ["roomInfo", "imService"]),
  },
  watch: {
    roomInfo: {
      handler(val) {
        this.focusModeValue = val.focus_mode_state;
        this.lockScreenModeValue = val.lock_screen_mode_state;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("live", ["setShowRaiseHand", "setRoomInfo"]),
    // 锁屏模式状态改变
    handleLockScreenModeChange(value) {
      if (value === 1) {
        this.lockScreenModeValue = 2;
        this.lockScreenModeDialogVisible = true;
      } else {
        this.updateRoomStatus({
          lock_screen_mode_state: 2,
        });
      }
    },
    // 锁屏模式开启确认
    handleLockScreenModeConfirm() {
      this.lockScreenModeValue = 1;
      this.updateRoomStatus({
        lock_screen_mode_state: 1,
      });
    },
    // 专注模式状态改变
    handleFocusModeChange(value) {
      this.updateRoomStatus({
        focus_mode_state: value,
      });
    },
    // 更改房间状态
    updateRoomStatus(params) {
      return new Promise((resolve, reject) => {
        updateRoomStatus({
          id: this.roomInfo.id,
          ...params,
        })
          .then((res) => {
            if (res.code === 1) {
              this.setRoomInfo(params);
              this.notifyLearnModeChange(params);
              resolve();
            } else {
              this.$darkMessage.error(res.message);
              reject();
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    notifyLearnModeChange(data) {
      if (this.imService) {
        const params = {};
        if (data.lock_screen_mode_state) {
          params.lockScreenMode = data.lock_screen_mode_state === 1;
        }
        if (data.focus_mode_state) {
          params.focusMode = data.focus_mode_state === 1;
        }
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "learnModeChange",
            data: params,
          },
        });
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
$border-color: #27272a;
.learning-setting-component {
  .tips {
    font-weight: 400;
    font-size: 14px;
    color: #c9cdd4;
    margin-bottom: 22px;
  }
  .sub-title {
    font-weight: 400;
    font-size: 14px;
    color: #c9cdd4;
    margin-bottom: 8px;
  }
  .setting-item {
    background: #27272a;
    border-radius: 12px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin-bottom: 12px;
    .item-title {
      font-weight: 400;
      font-size: 16px;
      color: #ecedee;
      line-height: 1;
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-left: 4px;
      }
    }
  }
}
::v-deep .el-switch__core {
  width: 54px !important;
  height: 30px;
  border: none;
  border-radius: 15px;
  &::after {
    width: 24px;
    height: 24px;
    top: 3px;
    left: 2px;
  }
}
::v-deep .el-switch.is-checked .el-switch__core::after {
  margin-left: -26px !important;
}
.tips-content {
  font-size: 14px;
  width: 200px;
  color: #c9cdd4;
  line-height: 1.5;
  text-align: left;
}
.tips-content-lock-screen {
  width: 200px;
  font-size: 14px;
  color: #f7f8fa;
  text-align: left;
}
</style>
